

























































































import Vue from 'vue'
import CategoryPostBreadcrumbs from '@/components/common/CategoryPostBreadcrumbs.vue'
import VideoPlayer from '@/components/product/VideoPlayer.vue'
import PostQueue from '@/components/product/PostQueue.vue'
import InstructorCard from '@/components/product/InstructorCard.vue'
import PostMaterialsCard from '@/components/product/PostMaterialsCard.vue'
import PostShimmer from '@/components/common/PostShimmer.vue'
import {
  CategoryService,
  ProductService,
  PostService,
  UserPostCompletionService,
  getUserId,
  UserProductTrackingService
} from '../services'
import Post from '../models/Post'
import { Instructor } from '../models/ProductCustomization'
import { extractInstructorInfoFromCustomization } from '../helper'
import Category, { CategoryVisibility } from '../models/Category'
import Product from '../models/Product'
import CategoryTreeNode, {
  CategoryTreeNodeType
} from '../models/CategoryTreeNode'
import { userAvatarImage } from '../helper/constants'
import { adminMode } from '@/helper/permission.helper'
export default Vue.extend({
  props: {
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    productStarted: Boolean
  },
  components: {
    CategoryPostBreadcrumbs,
    VideoPlayer,
    PostQueue,
    PostMaterialsCard,
    InstructorCard,
    PostShimmer
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    categoryId(): string {
      return this.$route.params.category_id
    },
    postId(): string {
      return this.$route.params.post_id
    },
    postCompletionButtonText(): string {
      if (this.disablePostCompletionButton) {
        return this.postMarkedAsCompleted
          ? 'Marking as Incomplete'
          : 'Completing..'
      } else {
        return this.postMarkedAsCompleted ? 'Completed' : 'Mark As Complete'
      }
    },
    isAdmin() {
      return adminMode()
    },
    markCompletedBtnCss() {
      if (this.disablePostCompletionButton || this.isAdmin) {
        return 'cursor-not-allowed'
      } else if (this.postMarkedAsCompleted) {
        return 'hover:bg-green-500 text-green-700 border-green-500 hover:text-white hover:border-transparent'
      }
      return 'hover:bg-blue-500 text-blue-700 border-blue-500 hover:text-white hover:border-transparent'
    }
  },
  async mounted() {
    this.fetchCategoryAndPosts(this.categoryId)
    await this.fetchPost(this.postId)
    this.checkIfPostCompleted(this.postId)
    this.fetchCompletedPosts()
    this.fetchNextCategory(this.categoryId)
  },
  data() {
    return {
      category: {} as Category,
      activePost: {} as Post,
      fetchingPost: false,
      fetchingPostCompletionStatus: true,
      postMarkedAsCompleted: false,
      disablePostCompletionButton: false,
      completedPostIds: new Set() as Set<string>,
      playlist: [] as Array<CategoryTreeNode>,
      nextCategoryId: ''
    }
  },
  methods: {
    async fetchCategoryAndPosts(categoryId: string) {
      this.category = await CategoryService.findById(categoryId, {
        published_posts: true
      })

      const subCategories = await CategoryService.findAll({
        parent_category: categoryId,
        published_posts: true,
        visibility: CategoryVisibility.published
      })

      const postNodes = this.category.posts.map(
        (p: Post) =>
          new CategoryTreeNode(p, CategoryTreeNodeType.Post, categoryId)
      )
      const subCategoryNodes = subCategories.map(
        (c: Category) =>
          new CategoryTreeNode(c, CategoryTreeNodeType.Category, categoryId)
      )

      this.playlist = [...postNodes, ...subCategoryNodes].sort(
        (a: CategoryTreeNode, b: CategoryTreeNode) =>
          a.sequenceNo - b.sequenceNo
      )
    },
    async fetchPost(postId: string) {
      this.fetchingPost = true
      try {
        this.activePost = await PostService.findById(postId)
      } catch (error) {
        console.error('Error while fetching post --> ', error)
      } finally {
        this.fetchingPost = false
      }
    },
    async togglePostCompletion() {
      try {
        this.disablePostCompletionButton = true

        if (this.postMarkedAsCompleted) {
          await this.markPostAsIncomplete()
          this.postMarkedAsCompleted = false
        } else {
          if (!this.productStarted) {
            UserProductTrackingService.trackProductStart(this.productId)
          }

          await this.markPostAsCompleted()
          this.postMarkedAsCompleted = true
        }
      } catch (error) {
        console.error('error while changing post completion status --> ', error)
      } finally {
        this.disablePostCompletionButton = false
      }
    },
    async checkIfPostCompleted(postId: string) {
      try {
        this.fetchingPostCompletionStatus = true

        const data = await UserPostCompletionService.checkIfPostCompleted(
          postId
        )

        if (data && data.length) {
          this.activePost.postCompletedRef = data[0].id
          this.postMarkedAsCompleted = true
        } else {
          this.postMarkedAsCompleted = false
        }
      } catch (error) {
        console.error('Error while checking if post is completed --> ', error)
      } finally {
        this.fetchingPostCompletionStatus = false
      }
    },
    async markPostAsCompleted() {
      const data = await UserPostCompletionService.markPostAsCompleted({
        postId: this.postId,
        productId: this.productId
      })

      this.activePost.postCompletedRef = data.id

      const completedPosts = this.completedPostIds
      completedPosts.add(this.activePost.id)
      this.completedPostIds = new Set(completedPosts)
    },
    async markPostAsIncomplete() {
      if (this.activePost.postCompletedRef) {
        await UserPostCompletionService.markPostAsIncomplete(
          this.activePost.postCompletedRef
        )
      }

      this.activePost.postCompletedRef = null

      const completedPosts = this.completedPostIds
      completedPosts.delete(this.activePost.id)
      this.completedPostIds = new Set(completedPosts)
    },
    async fetchCompletedPosts() {
      const userId = getUserId()

      const completedResp = await UserPostCompletionService.findAll({
        product_id: this.productId,
        user_id: userId
      })

      this.completedPostIds = completedResp.reduce(
        (agg: Set<string>, completed: any) => {
          const { postId } = completed
          agg.add(postId)
          return agg
        },
        new Set()
      )
    },
    async fetchNextCategory(categoryId: string) {
      const nextCategoryId = await CategoryService.findNextCategory(categoryId)
      console.log('found next category --> ', nextCategoryId)
      this.nextCategoryId = nextCategoryId
    }
  },
  watch: {
    async postId(newValue) {
      await this.fetchPost(newValue)
      await this.checkIfPostCompleted(newValue)
    },
    async categoryId(newValue) {
      this.fetchCategoryAndPosts(newValue)
      this.fetchNextCategory(newValue)
    }
  }
})
